/**
 * Service layer — the Threads hill (2026-08-27).
 *
 * The Flight Tracker's second curve. Every open Thread (this app's tracked entity — RFIs,
 * Submittals, coordination items, not a Slack discussion thread) appears on it automatically;
 * there is no "put in the air" ceremony the way a milestone becomes a flight, since a Thread
 * has no queued phase — see api/thread-hill.js's own doc comment for why.
 *
 * All access goes through /api/thread-hill (Clerk-authed, manager-and-up, mirrors
 * services/flights.js exactly). See docs/FLIGHT_PLAN.md and database/197_thread_hill.sql.
 */

async function post(body) {
  const token = (typeof window !== 'undefined' && window.__clerkGetToken) ? await window.__clerkGetToken() : null
  const res = await fetch('/api/thread-hill', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify(body),
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || ('Request failed: ' + res.status))
  return json
}

/**
 * The whole threads board: every open thread with its judged hill position.
 *
 * `projectDirectory` (id → name) tops up threads whose project name we didn't resolve
 * server-side — same fill-in the flights half of the board already does with the same map.
 */
export async function getThreadHillPlan(projectDirectory) {
  const plan = await post({ action: 'threadHillPlan' })
  if (projectDirectory) {
    const fill = (t) => {
      if (!t.projectName && t.projectId && projectDirectory[t.projectId]) t.projectName = projectDirectory[t.projectId]
      return t
    }
    plan.threads = (plan.threads || []).map(fill)
    plan.landed = (plan.landed || []).map(fill)
  }
  return plan
}

/** Move a thread along its hill. `position` is 0..1. The note is required upstream, not here. */
export function setThreadHill(threadId, position, note) {
  return post({ action: 'setHill', threadId, position, note })
}

/** One thread's movement record, newest first. */
export function getThreadHillHistory(threadId) {
  return post({ action: 'hillHistory', threadId })
}

/** Replay data for the shared history scrubber — see getHillTimeline in services/flights.js. */
export function getThreadHillTimeline(days) {
  return post({ action: 'hillTimeline', days })
}

/** Pull a thread off the curve without closing it. Closing itself lands it automatically. */
export function landThread(threadId) {
  return post({ action: 'land', threadId })
}
